import { IconFont, pointer } from '@lighthouse/bui'
import styled from 'styled-components'

export const Layout = styled.div`
    position: relative;
`

export const Container = styled.div`
    display: flex;
    /* position: relative; */

    .monaco-editor .monaco-editor-background,
    .margin-view-overlays {
        background-color: #e4e7ec !important;
    }
`

export const Left = styled.div`
    padding: 0 32px;
    width: 50%;
`

export const CenterBorder = styled.div<{ height?: number }>`
    width: 1px;
    height: ${({ height }) => height}px;
    background: var(--color-gray-200);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
`

export const Right = styled.div`
    width: 50%;
`

export const Title = styled.div`
    color: var(--color-gray-900);
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    margin-bottom: 8px;
`

export const Desc = styled.div`
    color: var(--color-gray-400);
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
`

export const Item = styled.div`
    margin-top: 20px;
`

export const ItemTitle = styled.div`
    color: var(--color-gray-900);
    font-size: 14px;
    line-height: 22px;
    margin-bottom: 12px;
`

export const Footer = styled.div<{ opacity: number }>`
    /* padding: 0 20px; */
    /* margin-top: 20px; */
    display: flex;
    justify-content: flex-end;
    /* height: 72px; */
    width: 100%;
    align-items: center;
    /* background: var(--color-gray-50); */
    border-radius: 0px 0px inherit inherit;
    gap: 12px;
    opacity: ${({ opacity }) => opacity};
    margin-top: 20px;
`

export const RightFooter = styled.div<{ display?: string }>`
    justify-content: flex-end;
    width: 100%;
    align-items: center;
    border-radius: 0px 0px inherit inherit;
    gap: 12px;
    margin-top: 20px;
    padding-right: 32px;
    display: ${({ display }) => display || 'flex'};
`

export const DefaultText = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 32px 0 32px;
    box-sizing: border-box;
`

export const Icon = styled(IconFont)<{ color?: string }>`
    font-size: 16px;
    color: ${({ color }) => color || 'var(--color-gray-500)'};
    ${pointer}
`

export const DefaultTextTitle = styled.div`
    color: var(--color-gray-400);
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    margin-top: 12px;
`

export const EditorContainer = styled.div`
    padding: 8px 12px;
    width: 100%;
    height: 100%;
    background-color: #e4e7ec;
    border-radius: 6px;
`

export const UpperLimitModal = styled.div`
    /* padding: 0 20px; */
    position: fixed;
    bottom: 0;
    top: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.3);
    z-index: 999999;
`

export const UpperInner = styled.div`
    width: 375px;
    box-shadow: 0px 4px 12px 0px #1018281a;
    background: #fff;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    padding: 20px;
    box-sizing: border-box;
    border-radius: 22px;
`

export const Close = styled.div`
    position: absolute;
    right: 20px;
    top: 20px;
    background: #26415a0f;
    width: 24px;
    height: 24px;
    border-radius: 34px;
    text-align: center;
    line-height: 24px;
`
export const UpperHeader = styled.div`
    display: flex;
    justify-content: flex-start;
`

export const IconOuter = styled.div`
    background: #eceff4;
    flex-shrink: 0;
    width: 48px;
    height: 48px;
    border-radius: 38px;
    border-radius: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
`

export const UpperHeaderContent = styled.div`
    margin-left: 16px;
    width: 100%;
`
export const UpperTitle = styled.div`
    color: var(--color-gray-900);
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    margin-bottom: 8px;
`
export const UpperDesc = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`
export const UpperDescLeft = styled.div`
    color: var(--color-gray-700);
    font-size: 12px;
    font-weight: 400px;
    line-height: 20px;
`
export const UpperDescRight = styled.div`
    color: #344054;
    font-size: 12px;
    font-weight: 400px;
    line-height: 20px;
`

export const UpperProgress = styled.div`
    background: var(--color-red-500);
    width: 100%;
    height: 6px;
    border-radius: 16px;
    margin-top: 4px;
    margin-bottom: 16px;
`

export const UpperFooter = styled.div`
    display: flex;
    justify-content: flex-end;
`

export const Look = styled.div`
    background: #eceff4;
    border-radius: 8px;
    padding: 5px 10px;
    font-size: 14px;
    color: #101323;
    cursor: pointer;
`

export const Upgrade = styled.div`
    background: #101828;
    margin-left: 13px;
    border-radius: 8px;
    padding: 5px 10px;
    font-size: 14px;
    color: #fff;
    cursor: pointer;
`
